import ModuleManager from "../../../framework/core/module_manager";

const { ccclass, property,  executeInEditMode, menu, inspector} = cc._decorator;

enum SelectState{
    UnSelect = 0,
    Select = 1,    
}

enum SaveState{
    None = 0,
    Save = 1,
}

@ccclass('CustomStyleClass')
class CustomStyle{
    @property(cc.String)
    name: string = ''

    @property({type:cc.Enum(SaveState), displayName:'保存'})
    value: number = 0

    @property({type:cc.Enum(SelectState), displayName:'选择'})
    select: number = 0
    
    lastSelectState: SelectState = SelectState.UnSelect
}

@ccclass
@executeInEditMode
@menu('custom/CustomUIStateSwitcher')
@inspector("packages://project/inspector/custom_ui_state_switcher.js")
export default class CustomUIStateSwitcher extends cc.Component {

    @property([CustomStyle])
    styleList: CustomStyle[] = []

    @property([cc.Node])//玩家座位信息父节点
    nodeList: cc.Node[] = []

    update(){
        if(cc.sys.platform == cc.sys.EDITOR_PAGE){
            this._updateEditor()
        }        
    }

    //用于更新label的显示状态
    private _updateEditor() {
        this._checkSave()
        this._checkSelect()
    }

    private _checkSelect(){
        let styleName = null
        for (let index = 0; index < this.styleList.length; index++) {
            const element = this.styleList[index];
            if(element.select == SelectState.Select && element.lastSelectState == SelectState.UnSelect){
                styleName = element.name                
                element.lastSelectState = SelectState.Select
                break
            }
        }
        if(styleName == null || styleName == ''){
            return
        }
        for (let index = 0; index < this.styleList.length; index++) {
            const element = this.styleList[index];
            if(element.name != styleName){
                element.lastSelectState = SelectState.UnSelect
                element.select = SelectState.UnSelect
            }
        }      
        this.SwitchState(styleName)  
    }

    private _checkSave(){
        let styleName = null
        for (let index = 0; index < this.styleList.length; index++) {
            const element = this.styleList[index];
            if(element.value == SaveState.Save){
                styleName = element.name
                element.value = SaveState.None
            }
        }
        if(styleName == null || styleName == ''){
            return
        }
        let nodeList = this.nodeList
        for (let index = 0; index < nodeList.length; index++) {
            const element = nodeList[index];
            if(element != null){
                this._refreshBrother(element, styleName)
            }
        }
    }

    private _refreshBrother(node, uiStyleName){
        let brother = this._findBrother(node, uiStyleName)
        if(brother == null){
            brother = this._instantiateBrother(node.parent)
            brother.name = this._getBrotherName(node, uiStyleName)
        }
        this._cloneBrotherTransform(brother, node)
        this._cloneBrotherActive(brother, node)
    }

    private _findBrother(node, uiStyleName){
        let brother = node.parent.getChildByName(this._getBrotherName(node, uiStyleName))
        return brother
    }

    private _getBrotherName(node, uiStyleName){
        return '_' + uiStyleName + '_' + node.name
    }

    private _instantiateBrother(parent){
        var node = new cc.Node()
        node.position = cc.v2(0, 0)
        node.scale = 1
        node.parent = parent
        return node
    }

    private _cloneBrotherTransform(node: cc.Node, brother: cc.Node){
        node.setPosition(brother.position)
        node.setScale(brother.scaleX, brother.scaleY)
        node.angle = brother.angle
        node.setAnchorPoint(brother.getAnchorPoint())
        node.setContentSize(brother.getContentSize())        
        node.color = brother.color        
        node.opacity = brother.opacity
        node.skewX = brother.skewX        
        node.skewY = brother.skewY        
        node.group = brother.group
    }

    private _cloneBrotherActive(node, brother){
        node.active = brother.active
    }

    SwitchState(styleName){
        if(styleName == null || styleName == ''){
            return
        }
        let nodeList = this.nodeList
        for (let index = 0; index < nodeList.length; index++) {
            let node = nodeList[index];
            if(node){
                let brother = this._findBrother(node, styleName)
                // Editor.log(styleName, brother.name)
                if(brother != null){
                    this._cloneBrotherTransform(node, brother)
                    this._cloneBrotherActive(node, brother)
                }
            }            
        }
    }
}
